//To pause the time while testing styles enter "clearInterval(countDownTimer);" in the console
jQuery( document ). ready( function( $ ) {
  var cloop = 0;
  
  // Automatic start and end times in UTC milliseconds
  // Can be found using https://www.epochconverter.com/
  // Use Human date to Timestamp with GMT timezone and select Timestamp in milliseconds value
  // Can enter multiple values with format "[STARTTIME,ENDTIME],"
  
  var endtimesExtendUTC = [
    [1764565200000,1764633600000]
  ];
  
  window.promoStartDate = new Date( 0 ).getTime();
  window.promoEndDate = new Date( 1 ).getTime();
  
  function countDownFunction() {
    var now = new Date().getTime();
    
    endtimesExtendUTC.forEach(function(timeUTC) {
        var hoffset = new Date().getTimezoneOffset();
        var starttime = timeUTC[0] + hoffset * 60000;
        var endtime = timeUTC[1] + hoffset * 60000;
      
        if( now >= starttime && now < endtime ){
            window.promoStartDate = new Date(starttime).getTime();
            window.promoEndDate = new Date(endtime).getTime();
        }
    });
  
    var remainingTime = window.promoEndDate - now;
    var startingTime = window.promoStartDate - now;
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    daysLeft = (Math.trunc(remainingTime / day));
    hoursLeft = (Math.trunc((remainingTime) / hour));
    minutesLeft = (Math.trunc((remainingTime % hour) / minute));
    secondsLeft = (Math.trunc((remainingTime % minute) / second));

    /*
    * Not Necessary but can be uncommented to debug start times
    daysToStart = (Math.trunc(startingTime / day));
    hoursToStart = (Math.trunc((startingTime) / hour));
    minutesToStart = (Math.trunc((startingTime % hour) / minute));
    secondsToStart = (Math.trunc((startingTime % minute) / second)); */

    secondsToPromo = (Math.trunc((startingTime) / second));
    secondsToEnd = (Math.trunc((remainingTime) / second));
    
    cloop++;
    if ( secondsToPromo > 0 || secondsToEnd < 0 ) {
      // No active countdown, remove element and stop running the javascript
      $( '.sale-countdown' ).remove();
      if ( countDownTimer != undefined ) {
        clearInterval( countDownTimer );
      }
      
      return;
    } else {
      // Update and display countdown timer
      MyDateString = '<span class="t hour">' + ('0' + String(hoursLeft)).slice(-2) + '</span>' + '<span class="d">:</span>' +
          '<span class="t min">' + ('0' + String(minutesLeft)).slice(-2) + '</span>' + '<span class="d">:</span>' +
          '<span class="t sec">' + ('0' + String(secondsLeft)).slice(-2) + '</span>';
  
  
      var CounterString = "<span class='pblock'>" +
          "<a href='/pages/collection' class='plink'>" +
          "<h2></h2>" +
          "<span class='pdate'>" + MyDateString + "</span>" +
          "</a>" +
          "</span>";
      $(".sale-countdown").html(CounterString);
  
      //English text
      if ( now < 1758244549000 ) {
        $( 'html[lang="en"] .sale-countdown h2' ).html( 'Sale Begins In: ' );
      } else {
        $( 'html[lang="en"] .sale-countdown h2' ).html( 'Sale Ends In: ' );
      }
      $( 'html[lang="en"] .sale-countdown a' ).attr( 'href', '/collections' );
      $( 'html[lang="en"] .sale-countdown .t.hour' ).attr( 'data-before', 'hours' );
      $( 'html[lang="en"] .sale-countdown .t.min' ).attr( 'data-before', 'minutes' );
      $( 'html[lang="en"] .sale-countdown .t.sec' ).attr( 'data-before', 'seconds' );

      //French Text
      if ( now < 1758244549000 ) {
        $( 'html[lang="fr"] .sale-countdown h2' ).html( 'La vente commence dans : ' );
      } else {
        $( 'html[lang="fr"] .sale-countdown h2' ).html( 'Vente se termine dans : ' );
      }
      $( 'html[lang="fr"] .sale-countdown a' ).attr( 'href', '/fr/collections' )
      $( 'html[lang="fr"] .sale-countdown .t.hour' ).attr( 'data-before', 'heures' );
      $( 'html[lang="fr"] .sale-countdown .t.min' ).attr( 'data-before', 'minutes' );
      $( 'html[lang="fr"] .sale-countdown .t.sec' ).attr( 'data-before', 'secondes' );
  
      $( '.t' ).html(function(index, html) {
          return html.replace( /\S/g, '<span>$&</span>' );
      });

      sessionStorage['sale_countdown_seen'] = true;
  
      $( '.sale-countdown' ).show();
    }
  };
  
  if ( !sessionStorage['sale_countdown_seen'] ) {
    countDownFunction();
    clearInterval( countDownTimer );
    var countDownTimer = setInterval(() => {
        countDownFunction();
    }, 1000);

    window.countDownTimer = countDownTimer;
  }
});